/* eslint-disable no-multi-spaces */
import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'

import { RiskProductsContext } from '../../context'
import { Formik, Form as FormikForm } from 'formik'
import { RiskProductFields } from './FormFields'
import { buildInitialValues } from './formService'
import { setupValidations } from './validations'
import { Button } from '@components/Button'
import { Grid } from '@components/layout/Grid'
import { humanizeString } from '@utils/stringMinipulation'
import bannerImg from '@assets/images/general_banner_img.png'

export const Form = () => {
  const { actions } = useContext(RiskProductsContext)
  const { submit } = actions

  return (
    <Formik
      onSubmit={(formRiskProduct) => submit(formRiskProduct)}
      validationSchema={setupValidations()}
      initialValues={buildInitialValues()}
      render={(formProps) => (
        <FormikForm>
          <Grid halfSplit className='app-form app-form--nested-in-card'>
            <Main formProps={formProps} />
            <Aside />
          </Grid>
        </FormikForm>
      )}
    />
  )
}

const Main = ({ formProps }) => {
  const { state, actions } = useContext(RiskProductsContext)
  const { submitLabel, deleteLabel, loading } = state
  const { back } = actions
  return (
    <section>
      <RiskProductFields
        values={formProps.values}
      />
      <Box className='grid grid-cols-2 gap-4'>
        <Button className='button button--secondary' onClick={back}>Back</Button>
        <Button className='button button--primary' type='submit' disabled={!formProps.isValid || loading}>
          {loading ? 'Loading...' : submitLabel}
        </Button>
        <Button disabled={loading} className='button button--tertiary col-span-2'>{deleteLabel}</Button>
      </Box>
    </section>
  )
}

const Aside = () => {
  const { state } = useContext(RiskProductsContext)
  const { formRiskProductType } = state
  return <DefaultAside formRiskProductType={formRiskProductType} />
}

const DefaultAside = ({ formRiskProductType }) =>
  <section className='info-section'>
    <h3>Add your <strong>{humanizeString(formRiskProductType)}</strong> information here.</h3>
    <img src={bannerImg} />
  </section>
